import { QueueLineColors } from './types';

// Zoom limits
export const MIN_ZOOM = 1.0; // Minimum zoom level (zoomed out)
export const MAX_ZOOM = 25.0; // Maximum zoom level (zoomed in)

// Selection overlay constants
export const SELECTION_COLOR = 0x257b8f;
export const SELECTION_OPACITY = 0.5;

// Queue line constants
export const MAX_QUEUE_LINE_SHOPPERS = 12;
export const MAX_QUEUE_LINES = 5;

// Queue line colors
export const queueLineColorMap = {
  1: QueueLineColors.TealBlue,
  2: QueueLineColors.Blue,
  3: QueueLineColors.Pink,
  4: QueueLineColors.Orange,
  5: QueueLineColors.Green,
};

// Model paths
export const FEMALE_BASKET_GLB = '/female-basket.glb';
export const FEMALE_CART_GLB = '/female-cart.glb';

// Snapping configuration constants
export const DEFAULT_GRID_SIZE = 0.25;
export const DEFAULT_SNAP_THRESHOLD = 0.2;
export const DEFAULT_SNAPPING_ENABLED = true;
export const DEFAULT_GRID_SNAPPING_ENABLED = true;
export const DEFAULT_EDGE_SNAPPING_ENABLED = true;

// Edge detection constants
export const OVERLAP_HIGHLIGHT_COLOR = 0xff0000;
export const OVERLAP_HIGHLIGHT_OPACITY = 0.5;
export const OUT_OF_BOUNDS_HIGHLIGHT_COLOR = 0xff6600;
export const OUT_OF_BOUNDS_HIGHLIGHT_OPACITY = 0.5;

// Snap visualization constants
export const SNAP_POINT_COLOR = 0xffff00;
export const SNAP_LINE_X_COLOR = 0x00ff00;
export const SNAP_LINE_Z_COLOR = 0x0000ff;
